import { createFileRoute } from "@tanstack/react-router";
import { Table } from "@heroui/react";

import { CreatePackagesPricesModal } from "@/features/packages-price/ui/create-packages-prices-modal.tsx";
import { PackagesPriceEntity } from "@/features/packages-price/type.ts";
import { usePackagesPrices } from "@/features/packages-price/use-packages-prices.ts";
import { DeletePackagesPricesModal } from "@/features/packages-price/ui/delete-packages-prices-modal.tsx";
import { EditPackagesPricesModal } from "@/features/packages-price/ui/edit-packages-prices-modal.tsx";
import { TogglePackagesPricesStatus } from "@/features/packages-price/ui/toggle-packages-prices-status.tsx";

export const Route = createFileRoute("/dashboard/packages-price")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = usePackagesPrices();

  return (
    <div className="flex flex-col pt-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Упаковки</p>

        <CreatePackagesPricesModal />
      </div>

      <Table.Root className="mt-8">
        <Table.Content aria-label="Список упаковок">
          <Table.Header>
            <Table.Column>Картинка</Table.Column>
            <Table.Column>Название</Table.Column>
            <Table.Column>Описание</Table.Column>
            <Table.Column>Цена</Table.Column>
            <Table.Column>Статус</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data?.data ?? []}>
            {(packages: PackagesPriceEntity) => (
              <Table.Row id={String(packages.id)}>
                <Table.Cell>
                  <img
                    src={packages.image}
                    alt={packages.name}
                    className="h-16 w-auto object-contain"
                  />
                </Table.Cell>
                <Table.Cell>{packages.name}</Table.Cell>
                <Table.Cell>{packages.description}</Table.Cell>
                <Table.Cell>{packages.price}</Table.Cell>
                <Table.Cell>
                  <TogglePackagesPricesStatus packages={packages} />
                </Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row gap-2 justify-end">
                    <EditPackagesPricesModal packagesId={packages.id} />

                    <DeletePackagesPricesModal packagesId={packages.id} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </div>
  );
}
